import  Home  from "./components/Home";
import  LogBookAircraft  from "./components/LogBookAircraft";
import  LogBookAdmin  from "./components/LogBookAdmin";
import  SmartHouseAdmin  from "./components/SmartHouseAdmin";
import  SmartHouse  from "./components/SmartHouse";
import  Login  from "./components/Login";

const AppRoutes = [
  {
    index: true,
    path: '/',
    element: <Home />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/LogBookAircraft',
    element: <LogBookAircraft />
  },
  {
    path: '/LogBookAdmin',
    element: <LogBookAdmin />
  },
  {
    path: '/SmartHouse',
    element: <SmartHouse />
  },
  {
    path: '/SmartHouseAdmin',
    element: <SmartHouseAdmin />
  },
  {
    path: '/login',
    element: <Login />
  }
];

export default AppRoutes;
